<!--Main Data-->
<div class="fd-Menu">
	<label>Location Code:</label>
	<input [(ngModel)]="Code" placeholder="Enter Location Code" class="form-control" type="text" />

	<label>Location Name:</label>
	<input [(ngModel)]="Name" placeholder="Enter Location Name" class="form-control" type="text" />
</div>

<!--Buttons-->
<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
